module.exports = __webpack_public_path__ + "img/category-new-released-hover.e7e18d49.png";